module.exports = __webpack_public_path__ + "static/media/generic-prin.4d70df6b.jpeg";